import React, { useEffect, useRef, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";


const features = [
  {
    title: "Journal",
    text: "Track your writing journey and progress over time.",
  },
  {
    title: "Characters",
    text: "Let your characters come to life and speak in your journal.",
  },
  {
    title: "Followers",
    text: "Build your author brand and grow a loyal audience.",
  },
];

const Home = () => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const userId = user?.uid ?? "";

  useEffect(() => {
    if (!loading && userId) {
      navigate("/feed", { replace: true });
    }
  }, [loading, userId, navigate]);

  return (
    <div className="flex flex-col min-h-screen">
      {/* Hero */}
      <section className="bg-white text-[#333333] py-20 text-center px-4">
        <h2 className="text-5xl font-extrabold mb-4">Welcome to Journē</h2>
        <p className="text-lg mb-8">
          A place where authors bring their stories to life.
        </p>
        <div className="space-x-4">
          <Link
            to="/register"
            className="bg-[#AEFFDE] hover:bg-[#9deecf] text-[#333333] px-6 py-3 rounded-lg font-semibold transition"
          >
            Get Started
          </Link>
          <Link
            to="/login"
            className="border border-[#333333] text-[#333333] px-6 py-3 rounded-lg font-semibold hover:bg-gray-100 transition"
          >
            Login
          </Link>
        </div>
      </section>

      {/* Features */}
      <section className="bg-[#E4F1FF] py-16 px-6 grow">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map(({ title, text }) => (
            <div
              key={title}
              className="bg-white border-l-8 border-[#AEFFDE] rounded-xl p-6 shadow"
            >
              <h3 className="text-2xl font-bold mb-2 text-[#333333]">{title}</h3>
              <p className="text-[#333333]">{text}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#333333] text-[#AEFFDE] py-6 text-center text-sm">
        © {new Date().getFullYear()} Journē. Built for writers, by writers.
      </footer>
    </div>
  )
}

export default Home;